import { render, staticRenderFns } from "./FooterWithLinks.vue?vue&type=template&id=5e539594&scoped=true"
import script from "./FooterWithLinks.vue?vue&type=script&lang=js"
export * from "./FooterWithLinks.vue?vue&type=script&lang=js"
import style0 from "./FooterWithLinks.vue?vue&type=style&index=0&id=5e539594&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e539594",
  null
  
)

export default component.exports